import type React from 'react';

/** Shared styles of the packing station (solid #667eea accent, no gradients, touch-sized controls). */
export const ACCENT = '#667eea';

export const btn = (variant: 'primary' | 'ghost' | 'danger' | 'warn' = 'ghost', small = false): React.CSSProperties => ({
  minHeight: small ? 36 : 44,
  padding: small ? '6px 12px' : '10px 16px',
  borderRadius: 8,
  fontSize: small ? 13 : 15,
  fontWeight: 600,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  border: variant === 'ghost' ? '1px solid #cbd5e1' : '1px solid transparent',
  background:
    variant === 'primary' ? ACCENT : variant === 'danger' ? '#dc2626' : variant === 'warn' ? '#f59e0b' : '#fff',
  color: variant === 'ghost' ? '#1e293b' : '#fff',
});

export const card: React.CSSProperties = {
  background: '#fff',
  borderRadius: 12,
  boxShadow: '0 1px 3px rgba(15,23,42,0.08)',
  border: '1px solid #e2e8f0',
};

export const th: React.CSSProperties = {
  padding: '10px 8px',
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.4px',
  color: '#475569',
  textAlign: 'left',
  background: '#f8fafc',
  borderBottom: '1px solid #e2e8f0',
  verticalAlign: 'bottom',
  lineHeight: 1.3,
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

export const td: React.CSSProperties = {
  padding: '8px 8px',
  fontSize: 13,
  color: '#1e293b',
  borderBottom: '1px solid #f1f5f9',
  verticalAlign: 'middle',
};

export const num: React.CSSProperties = { ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums' };

export const badge = (bg: string, color: string): React.CSSProperties => ({
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 800,
  letterSpacing: '0.3px',
  background: bg,
  color,
  marginRight: 4,
  whiteSpace: 'nowrap',
});

export const input: React.CSSProperties = {
  width: '100%',
  minHeight: 44,
  padding: '10px 12px',
  border: '1px solid #cbd5e1',
  borderRadius: 8,
  fontSize: 16,
  boxSizing: 'border-box',
};

export const overlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15,23,42,0.5)',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
};

export const dialog = (width = 460): React.CSSProperties => ({
  ...card,
  width: '100%',
  maxWidth: width,
  maxHeight: 'calc(100vh - 32px)',
  overflowY: 'auto',
  padding: 'clamp(16px, 3vw, 24px)',
});

export const nowrap: React.CSSProperties = { whiteSpace: 'nowrap' };

/** Readable by screen readers only (e.g. the header of the actions column). */
export const visuallyHidden: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
};
